import * as React from 'react';
import PropTypes from 'prop-types';
import { Logger } from '../core';
import { ErrorBoundaryProps, ErrorBoundaryState } from './types/propTypes';
import { isNextJsNavigation } from './utils/errorHandlers';

const logger = Logger.getInstance();

/** React ErrorBoundary - Best practice for catching React errors */
export class NextGenErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static propTypes = {
    children: PropTypes.node.isRequired,
    componentName: PropTypes.string.isRequired,
  };

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    // Don't block Next.js navigation
    if (!isNextJsNavigation(error)) {
      logger.error(`ErrorBoundary caught error in ${this.props.componentName}:`, error);
    } else {
      throw error;
    }
  }

  render() {
    if (this.state.hasError) {
      return null; // Graceful degradation
    }
    return this.props.children;
  }
}
